import { IAgencyPermission } from "shared/services/api/agents/agentsService";
import { AccessType, IUserAgency } from "shared/models/user";
import { sortBy } from "lodash";

export function convertPerformerAgencyList(
  agencyPermissions: IAgencyPermission[] | null | undefined,
  accessType: AccessType | undefined
): IUserAgency[] {
  if (!agencyPermissions || accessType !== AccessType.Nudge) {
    return [];
  }

  return agencyPermissions
    .filter((item) => item.allowNudge)
    .map((item) => ({ agencyId: item.agencyId, agencyName: item.name }));
}

export function convertPerformerAccessType(
  agencyPermissions: IAgencyPermission[] | null | undefined
): AccessType | undefined {
  if (!agencyPermissions) {
    return;
  }

  const lowestPermission: IAgencyPermission | undefined = sortBy(
    agencyPermissions,
    [
      (permission) => permission.allowSelfSuggest,
      (permission) => permission.allowNudge,
    ]
  )[0];

  if (lowestPermission?.allowSelfSuggest) return AccessType.Full;

  if (lowestPermission?.allowNudge) return AccessType.Nudge;

  return AccessType.ReadOnly;
}
